<ds-loading *ngIf="(loading | async) || (isAuthenticated | async)" class="m-5"></ds-loading>
<div *ngIf="(loading | async) !== true && (isAuthenticated | async) !== true" class="px-4 py-3 mx-auto login-container">
  <ng-container *ngFor="let authMethod of (authMethods | async); let last = last">
    <ds-log-in-container [authMethod]="authMethod" [isStandalonePage]="isStandalonePage"></ds-log-in-container>
    <div *ngIf="!last" class="dropdown-divider my-2"></div>
  </ng-container>
  <ng-container *ngIf="canShowDivider$ | async">
    <div class="mt-2">
      <a class="dropdown-item" *ngIf="canRegister$ | async" [routerLink]="[getRegisterRoute()]"
         [attr.data-test]="'register' | dsBrowserOnly">{{"login.form.new-user" | translate}}</a>
      <a class="dropdown-item" *ngIf="canForgot$ | async" [routerLink]="[getForgotRoute()]"
         [attr.data-test]="'forgot' | dsBrowserOnly">{{"login.form.forgot-password" | translate}}</a>
    </div>
  </ng-container>
</div>
